import React, {useEffect, useRef, useState} from "react"
import {AiOutlineCloseCircle} from "react-icons/ai";
import {
    Button,
    Checkbox,
    FormItem,
    Input,
    Link,
    NativeSelect,
    ScreenSpinner,
    Snackbar,
    Textarea
} from "@vkontakte/vkui";
import InputMask from 'react-input-mask';
import Image from "../rest/Image"
import User from "../rest/User";
import {buildOrderPreviewPhotosFromFiles} from "../utils/buildOrderPreviewPhotos";
import {ReCAPTCHA} from "react-google-recaptcha";

const logSaveStage = () => {};
const ORDER_EXPORT_JPEG_QUALITY = 0.88;

const TakeOrder = ({closePop, callback, openPreview, uniqId, files, types, sizes, shops, isCroppingMode = false, autoStart = false}) => {
    const safeShops = Array.isArray(shops) ? shops : [];
    const [fio, setFio] = useState("");
    const [selectShop, setSelectShop] = useState((safeShops[0] && safeShops[0]._id) ? safeShops[0]._id : "")
    const selectedShopInfo = safeShops.find(x => x._id === selectShop) || safeShops[0] || {name: "Не выбран", adres: "-", phone: "-", time: "-"};
    const [fioError, setFioError] = useState(false);
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState(false);
    const [email, setEmail] = useState("");
    const [comment, setComment] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [loading, setLoading] = useState(isCroppingMode && autoStart)
    const [policy,setPolicy] = useState(false)
    const [loadingPrev,setLoadingPrev] = useState(false)
    const [uploadedFiles,setUploadedFiles] = useState(0)
    const [totalToUpload, setTotalToUpload] = useState(0)
    const [saveProgress, setSaveProgress] = useState(0)
    const [isFinalizing, setIsFinalizing] = useState(false)
    /** Режим обрезки: один раз запускаем go() после загрузки sizes (иначе selectedSize = null и все фото пропускаются). */
    const croppingAutoSaveLaunchedRef = useRef(false)
    const [saveStage, setSaveStage] = useState("idle")
    const [preparedFiles, setPreparedFiles] = useState(0)
    const [finalizingCreatedFiles, setFinalizingCreatedFiles] = useState(0)
    const [finalizingMessage, setFinalizingMessage] = useState("")
    const [finalizingServerStage, setFinalizingServerStage] = useState("")
    const [finalizingServerTotal, setFinalizingServerTotal] = useState(0)
    const uploadOneWithRetry = async (item, orderId, maxAttempts = 3) => {
        let lastError = null;
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
            try {
                logSaveStage(isCroppingMode, "send_photo:attempt", {
                    orderId,
                    photo: item.photo,
                    attempt,
                    hasUrl: Boolean(item.url),
                    renderedFile: item.renderedFile || null,
                });
                await User.sendOrderPhoto({
                    selectedSize: item.selectedSize,
                    url: item.url,
                    renderedFile: item.renderedFile,
                    count: item.count,
                    photo: item.photo
                }, orderId);
                logSaveStage(isCroppingMode, "send_photo:ok", {orderId, photo: item.photo, attempt});
                return;
            } catch (err) {
                lastError = err;
                logSaveStage(isCroppingMode, "send_photo:retry", {
                    orderId,
                    photo: item.photo,
                    attempt,
                    message: err && err.message,
                    status: err && err.response && err.response.status,
                    data: err && err.response && err.response.data,
                });
                await new Promise((resolve) => setTimeout(resolve, 250 * attempt));
            }
        }
        logSaveStage(isCroppingMode, "send_photo:failed", {
            orderId,
            photo: item.photo,
            message: lastError && lastError.message,
        });
        throw lastError || new Error("Upload failed");
    };
    const resolveSelectedSizeId = (photoItem) => {
        if (photoItem && photoItem.selectedSize && photoItem.selectedSize._id) {
            return photoItem.selectedSize._id;
        }
        if (sizes && sizes[0] && sizes[0]._id) {
            return sizes[0]._id;
        }
        return null;
    };
    const preparePhotoForUpload = (photoItem, fallbackPhotoName, selectedSizeId, photoCount) => {
        const bordersMode = photoItem && photoItem.borders ? photoItem.borders : "Без полей";
        const noBordersCanvas =
            photoItem && (photoItem.canvas_noborders || photoItem.canvas_bz);
        const noBordersOk =
            noBordersCanvas && noBordersCanvas.width > 0 && noBordersCanvas.height > 0;
        /* В /cropping canvas_noborders — только кроп «без полей»; с белыми полями на сервер должен уходить preview (canvas). */
        const useCroppingNoBorders =
            isCroppingMode && noBordersOk && bordersMode !== "С полями";
        const canvas = useCroppingNoBorders
            ? noBordersCanvas
            : bordersMode === "С полями"
                ? photoItem.canvas
                : (photoItem.canvas_noborders || photoItem.canvas_bz);
        let dataURL = null;
        if (canvas) {
            try {
                dataURL = canvas.toDataURL('image/jpeg', ORDER_EXPORT_JPEG_QUALITY);
            } catch (e) {
                /* ignore */
            }
        }
        if (dataURL) {
            return {
                selectedSize: selectedSizeId,
                url: dataURL,
                count: photoCount,
                photo: fallbackPhotoName
            };
        }
        return {
            selectedSize: selectedSizeId,
            renderedFile: fallbackPhotoName,
            count: photoCount,
            photo: fallbackPhotoName
        };
    };
    const uploadWithConcurrency = async (items, limit, totalItems) => {
        let uploaded = 0;
        let skippedNoSize = 0;
        let index = 0;
        logSaveStage(isCroppingMode, "upload:batch_start", {
            totalItems,
            workers: Math.min(limit, items.length),
            orderId: uniqId,
            firstSizeId: sizes && sizes[0] ? sizes[0]._id : null,
        });
        const workers = new Array(Math.min(limit, items.length)).fill(0).map(async () => {
            while (index < items.length) {
                const currentIndex = index++;
                const currentItem = items[currentIndex];
                const selectedSizeId = resolveSelectedSizeId(currentItem);
                if (!selectedSizeId) {
                    skippedNoSize += 1;
                    logSaveStage(isCroppingMode, "upload:skip_no_size", {
                        index: currentIndex,
                        photo: currentItem && currentItem.photo,
                        hasItemSelectedSize: Boolean(
                            currentItem && currentItem.selectedSize && currentItem.selectedSize._id
                        ),
                        sizesLoaded: Array.isArray(sizes) ? sizes.length : 0,
                    });
                    continue;
                }
                const photoCount = currentItem && currentItem.count ? currentItem.count : 1;
                const photoName = currentItem && currentItem.photo ? currentItem.photo : `${uniqId}_${currentIndex}`;
                const prepared = preparePhotoForUpload(currentItem, photoName, selectedSizeId, photoCount);
                logSaveStage(isCroppingMode, "upload:prepare", {
                    index: currentIndex,
                    photo: photoName,
                    selectedSizeId,
                    mode: prepared.url ? "dataURL" : "renderedFile",
                });
                setPreparedFiles(prev => prev + 1);
                await uploadOneWithRetry(prepared, uniqId);
                uploaded += 1;
                setUploadedFiles(prevState => {
                    const next = prevState + 1;
                    const uploadProgress = totalItems > 0 ? Math.round((next / totalItems) * 90) : 0;
                    setSaveProgress(Math.min(90, uploadProgress));
                    return next;
                });
            }
        });
        await Promise.all(workers);
        logSaveStage(isCroppingMode, "upload:batch_done", {
            uploaded,
            skippedNoSize,
            expected: items.length,
        });
        return {uploaded, skippedNoSize, expected: items.length};
    };
    const waitForOrderCompletion = async (orderId, totalFiles) => {
        const startedAt = Date.now();
        const timeoutMs = 1000 * 60 * 20;
        let consecutiveNetworkErrors = 0;
        let lastStatusKey = "";
        logSaveStage(isCroppingMode, "finalize:wait_start", {orderId, totalFiles});
        while (Date.now() - startedAt < timeoutMs) {
            let data = null;
            try {
                const response = await User.getOrderStatus(orderId);
                data = response && response.data ? response.data : null;
                consecutiveNetworkErrors = 0;
            } catch (err) {
                consecutiveNetworkErrors += 1;
                logSaveStage(isCroppingMode, "finalize:status_error", {
                    orderId,
                    consecutiveNetworkErrors,
                    message: err && err.message,
                });
                setFinalizingMessage("Пробуем восстановить соединение...");
                if (consecutiveNetworkErrors >= 15) {
                    throw new Error("Потеряно соединение с сервером во время ожидания статуса заказа");
                }
                await new Promise((resolve) => setTimeout(resolve, 1000));
                continue;
            }
            if (!data || !data.exists) {
                logSaveStage(isCroppingMode, "finalize:status_pending", {
                    orderId,
                    exists: Boolean(data && data.exists),
                });
                await new Promise((resolve) => setTimeout(resolve, 700));
                continue;
            }
            const progress = data.progress || {};
            const stage = progress.stage || "";
            const processed = Number(progress.processed || 0);
            const total = Number(progress.total || 0);
            const message = progress.message || "";
            const statusKey = `${data.status}|${stage}|${processed}|${total}`;
            if (statusKey !== lastStatusKey) {
                lastStatusKey = statusKey;
                logSaveStage(isCroppingMode, "finalize:status", {
                    orderId,
                    status: data.status,
                    stage,
                    processed,
                    total,
                    message: message || null,
                    error: data.error || null,
                });
            }
            setFinalizingServerStage(stage);
            setFinalizingServerTotal(total);
            if (message) {
                setFinalizingMessage(message);
            }
            if ((stage === "read_metadata" || stage === "processing") && totalFiles > 0) {
                setSaveProgress((prev) => Math.max(prev, 91));
            } else if (stage === "create_files" && total > 0) {
                const created = Math.min(totalFiles, processed);
                setFinalizingCreatedFiles(created);
                const ratio = created / Math.max(1, totalFiles);
                setSaveProgress((prev) => Math.max(prev, Math.min(97, 90 + Math.round(ratio * 7))));
            } else if (stage === "create_previews" && total > 0) {
                const ratio = processed / Math.max(1, total);
                setSaveProgress((prev) => Math.max(prev, Math.min(99, 97 + Math.round(ratio * 2))));
            } else if (stage === "finalizing") {
                setSaveProgress((prev) => Math.max(prev, 99));
            }
            if (data.status === "done") {
                setFinalizingCreatedFiles(totalFiles);
                logSaveStage(isCroppingMode, "finalize:done", {orderId, totalFiles});
                return;
            }
            if (data.status === "failed") {
                logSaveStage(isCroppingMode, "finalize:failed", {orderId, error: data.error});
                throw new Error(data.error || "Ошибка обработки заказа");
            }
            await new Promise((resolve) => setTimeout(resolve, 700));
        }
        logSaveStage(isCroppingMode, "finalize:timeout", {orderId});
        throw new Error("Истекло время ожидания обработки заказа");
    };
    const go = async () => {
        logSaveStage(isCroppingMode, "go:enter", {
            uniqId,
            filesPropLength: Array.isArray(files) ? files.length : 0,
            sizesLength: Array.isArray(sizes) ? sizes.length : 0,
            autoStart,
        });
        let ok = true;
        if (!isCroppingMode && (!email || email.indexOf("@") === -1)) {
            setEmailError(true)
            ok = false
        }
        if (!isCroppingMode && !phone) {
            setPhoneError(true)
            ok = false
        }
        if (!isCroppingMode && !fio) {
            setFioError(true)
            ok = false
        }
        if (!ok) {
            logSaveStage(isCroppingMode, "go:aborted_validation", {});
            return;
        }

        setLoading(true)
        setUploadedFiles(0)
        setPreparedFiles(0)
        setFinalizingCreatedFiles(0)
        setFinalizingMessage("")
        setFinalizingServerStage("")
        setFinalizingServerTotal(0)
        setSaveProgress(0)
        setIsFinalizing(false)
        setSaveStage("preparing")

        let meme = files.filter((x) => x && x.delete !== true);
        setTotalToUpload(meme.length)
        logSaveStage(isCroppingMode, "go:after_filter", {activeFiles: meme.length});
        if (meme.length === 0) {
            logSaveStage(isCroppingMode, "go:error_no_files", {});
            setLoading(false);
            setSaveStage("error");
            alert("Не удалось подготовить фотографии к сохранению.");
            return;
        }
        setSaveStage("uploading")
        const uploadStats = await uploadWithConcurrency(meme, 4, meme.length);
        if (uploadStats.uploaded === 0 && meme.length > 0) {
            const msg =
                "Не отправлено ни одного фото: нет размера (sizes) или все кадры пропущены.";
            logSaveStage(isCroppingMode, "go:error_zero_uploads", uploadStats);
            setLoading(false);
            setSaveStage("error");
            alert(msg);
            return;
        }
        setIsFinalizing(true)
        setSaveStage("finalizing")
        const expectedFiles = Math.max(1, meme.length)

        const payload = {
            order_id: uniqId,
            email: isCroppingMode ? "crop@local" : email,
            fio: isCroppingMode ? "crop" : fio,
            shop: selectedShopInfo,
            phone: isCroppingMode ? "-" : phone,
            comment: isCroppingMode ? "cropping mode save" : comment
        };
        try {
            logSaveStage(isCroppingMode, "go:create_order", {
                type: isCroppingMode ? "new_cropping_order" : "new_order",
                order_id: payload.order_id,
            });
            const createOrderRequest = isCroppingMode ? User.createCroppingOrder(payload) : User.createOrder(payload);
            const r = await createOrderRequest;
            logSaveStage(isCroppingMode, "go:create_order_response", {
                data: r && r.data,
            });
            const resp = r && r.data;
            if (resp && resp.success === false) {
                throw new Error(resp.mess || resp.error || "Ошибка оформления заказа");
            }
            if (resp && resp.queued && resp.jobId) {
                await waitForOrderCompletion(resp.jobId, expectedFiles);
            } else {
                logSaveStage(isCroppingMode, "go:no_queue_job", {data: resp});
            }
            setSaveProgress(100)
            setFinalizingCreatedFiles(expectedFiles)
            setLoading(false)
            setIsFinalizing(false)
            setSaveStage("done")
            logSaveStage(isCroppingMode, "go:success_callback", {mess: resp && resp.mess});
            callback(resp)
        } catch (err) {
            logSaveStage(isCroppingMode, "go:catch", {
                message: err && err.message,
                status: err && err.response && err.response.status,
                responseData: err && err.response && err.response.data,
                stack: err && err.stack,
            });
            alert(`Произошла ошибка - ${err.message}`)
            setLoading(false)
            setIsFinalizing(false)
            setSaveStage("error")
        }

    }
    const goRef = useRef(go);
    goRef.current = go;
    useEffect(()=>{
        if(loading){

        }
    },[loading])
    useEffect(() => {
        if (!isCroppingMode || !autoStart) {
            return;
        }
        if (croppingAutoSaveLaunchedRef.current) {
            return;
        }
        if (!Array.isArray(sizes) || !sizes[0] || !sizes[0]._id) {
            logSaveStage(true, "crop:auto_start_wait_sizes", {
                sizesLength: Array.isArray(sizes) ? sizes.length : 0,
            });
            return;
        }
        const hasActive = Array.isArray(files) && files.some((x) => x && x.delete !== true);
        if (!hasActive) {
            logSaveStage(true, "crop:auto_start_wait_files", {
                filesLength: Array.isArray(files) ? files.length : 0,
            });
            return;
        }
        logSaveStage(true, "crop:auto_start_launch_go", {uniqId, sizesOk: true});
        croppingAutoSaveLaunchedRef.current = true;
        void goRef.current();
    }, [isCroppingMode, autoStart, sizes, files, uniqId]);
    useEffect(() => {
        if (!selectShop && safeShops[0] && safeShops[0]._id) {
            setSelectShop(safeShops[0]._id);
        }
    }, [selectShop, safeShops]);
    const stageLabel = saveStage === "preparing"
        ? `Подготовка файлов ${preparedFiles}/${totalToUpload}`
        : saveStage === "uploading"
            ? `Загрузка файлов ${uploadedFiles}/${totalToUpload}`
            : saveStage === "finalizing"
                ? (finalizingServerStage !== "create_files"
                    ? `Формируем заказ... ${finalizingMessage || "Подготовка задания на сервере"}`
                    : `Формируем заказ... Создано файлов ${finalizingCreatedFiles}/${finalizingServerTotal || totalToUpload}`)
                : "Загрузка";
    const loadingOverlay = (
        <div className={"loading_order"}>
            <span className={"font_montserrat w_500"} style={{fontSize: 30, marginBottom: 150}}>Загрузка</span>
            <ScreenSpinner size={"large"}/>
            <div style={{width: "70%", maxWidth: 520, marginTop: 24}}>
                <div style={{height: 10, borderRadius: 8, overflow: "hidden", backgroundColor: "#d9d9d9"}}>
                    <div style={{height: "100%", width: `${saveProgress}%`, backgroundColor: "#23D160", transition: "width .2s ease"}} />
                </div>
                <div style={{display: "flex", justifyContent: "space-between", marginTop: 10}}>
                    <span>{stageLabel}</span>
                    <span>{saveProgress}%</span>
                </div>
            </div>
        </div>
    )
    if (isCroppingMode && autoStart) {
        return (
            <div className={"content take_order_content"}>
                {loadingOverlay}
            </div>
        )
    }
    const showPrev = () => {
        openPreview(buildOrderPreviewPhotosFromFiles(files));
    }
    const onChange = (value) => {

    }
    return (
        <div className={"content take_order_content"}>
            <div style={{width: "100%", display: "flex", justifyContent: "flex-end"}}>
                <button
                    type="button"
                    onClick={closePop}
                    style={{position: "relative", alignSelf: "flex-end", justifySelf: "flex-end"}}
                    className={"close_cropik"}
                >
                    <AiOutlineCloseCircle color={"red"} size={30}/>
                </button>
            </div>
            {!isCroppingMode && <div className={"form_files"}>
                <div className={"main_inputs"} style={{width: "100%", display: "flex", flexDirection: "row"}}>
                    <FormItem top={"Фамилия, Имя, Отчество"}
                              style={{flex: .4}}
                              status={!fioError ? "" : "error"}
                              bottom={
                                  !fioError
                                      ? ""
                                      : "Пожалуйста, введите свое ФИО"
                              }
                    >
                        <Input value={fio} onChange={(e) => {
                            setFioError(false)
                            setFio(e.currentTarget.value)
                        }}/>
                    </FormItem>
                    <FormItem
                        style={{flex: .4}}
                        status={!phoneError ? "" : "error"}
                        bottom={
                            !phoneError
                                ? ""
                                : "Пожалуйста, введите контактный телефон"
                        }
                        top={"Контактный телефон"}>
                        <InputMask mask="+7(999) 999-99-99" value={phone} onChange={(e) => {
                            setPhoneError(false)
                            setPhone(e.currentTarget.value)
                        }}>
                            {(inputProps) => <Input {...inputProps} type="tel" disableUnderline/>}
                        </InputMask>
                    </FormItem>
                    <FormItem
                        style={{flex: .4}}
                        status={!emailError ? "" : "error"}
                        bottom={
                            !emailError
                                ? ""
                                : "Пожалуйста, введите электронную почту"
                        }
                        top={"Email"}>
                        <Input value={email} onChange={(e) => {
                            setEmailError(false)
                            setEmail(e.currentTarget.value)
                        }}/>
                    </FormItem>
                </div>
                <FormItem style={{width: "100%", paddingTop: 0}} top={"Комментарий к заказу"}>
                    <Textarea value={comment} onChange={(e) => setComment(e.currentTarget.value)}/>
                </FormItem>
                <div className={"shop_div"}>
                    <div className={"shopik"}>
                        <FormItem style={{flex:.5,padding:0}} top={"Выберите фотоцентр"}>
                            <NativeSelect value={selectShop} onChange={(e) => setSelectShop(e.target.value)}>
                                {safeShops.map((item, key) => (
                                    <option key={key} value={item._id}>{item.name}</option>
                                ))}
                            </NativeSelect>
                        </FormItem>
                        {safeShops.length > 0 && (
                            <div className={"_shop_info"} style={{display: "flex",paddingLeft:10, flexDirection: "column",flex:.5}}>
                                <div>
                                    <span
                                        className={"font_montserrat w_700"}>{selectedShopInfo.name}</span>
                                </div>
                                <div>
                                    <span className={"font_montserrat w_500"} style={{marginRight: 5}}>Адрес:</span>
                                    <span style={{color: "grey"}}>{selectedShopInfo.adres}</span>
                                </div>
                                <div>
                                    <span className={"font_montserrat w_500"} style={{marginRight: 5}}>Телефон:</span>
                                    <span style={{color: "grey"}}>{selectedShopInfo.phone}</span>
                                </div>
                                <div>
                                    <span className={"font_montserrat w_500"}
                                          style={{marginRight: 5}}>График работы:</span>
                                    <span style={{color: "grey"}}>{selectedShopInfo.time}</span>
                                </div>
                            </div>
                        )

                        }
                    </div>

                </div>

            </div>}
            {isCroppingMode && (
                <div style={{marginTop: 20, marginBottom: 10}}>
                    <span className={"font_montserrat w_700"}>Контактные данные не требуются в режиме обрезки</span>
                </div>
            )}
            {!isCroppingMode && <Checkbox onClick={()=>setPolicy(prevState => !prevState)} className={"font_montserrat w_700 pol_se"} style={{marginTop:10,fontWeight:700}} checked={policy}>
                Согласие с&nbsp;
                <Link target={"_blank"} href={"https://www.хорошо-нн.рф/policy"}>Политикой в отношении обработки персональных данных</Link>.
            </Checkbox>}
            {!isCroppingMode && <ReCAPTCHA
                size={"normal"}
                sitekey="6LfZh94eAAAAAI2jPsQsYiDWFC7P3d0xWDyoICer"
                onChange={onChange}
            />}
            <div style={{width: "100%", display: "flex",alignItems:"center",justifyContent:"center", flexDirection: "row"}}>
                <Button style={{width: 300,maxWidth:300, margin: 10}} stretched size={"m"} mode={"outline"} onClick={showPrev}>Мои
                    фотографии</Button>

                <Button disabled={loading || (!isCroppingMode && !policy)} onClick={go} stretched style={{width: 300,maxWidth:300, margin: 10}} size={"m"}
                        mode={"commerce"}>{loading ? "Сохраняем..." : (isCroppingMode ? "Сохранить" : "Заказать")}</Button>
            </div>
            {loading && loadingOverlay}
            {loadingPrev}
        </div>
    )
}
export default TakeOrder